export interface IOdataResult<T> {
  count: number;
  items: T[];
  nextPageLink: string;
}

function EmptyOdataResult<T>() {
  return {
    count: 0,
    items: [] as T[],
    nextPageLink: '',
  } as IOdataResult<T>;
}

export { EmptyOdataResult };
